module.exports = __webpack_public_path__ + "img/shop-map3.8af7e8f0.jpg";